module.exports = __webpack_public_path__ + "static/argo_card-2d9491cd2583456f51de3c28b628d48a.png";